"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Standard = exports.Box = exports.Radio = void 0;
var React = __importStar(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var styles = __importStar(require("./styles.modules.css"));
var icon_1 = require("../icon");
var cx = bind_1.default.bind(styles);
var Radio = /** @class */ (function (_super) {
    __extends(Radio, _super);
    function Radio() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onKeyUp = function (event) {
            if (event.key.toLowerCase() === "enter") {
                _this.select();
            }
        };
        _this.select = function () {
            var _a = _this.props, name = _a.name, onChange = _a.onChange, option = _a.option;
            onChange(name, option.value);
        };
        return _this;
    }
    Radio.prototype.render = function () {
        var _a = this.props, option = _a.option, selected = _a.selected, renderer = _a.renderer;
        var element = renderer(option, selected);
        return React.cloneElement(element, __assign({ onKeyUp: this.onKeyUp, onMouseDown: this.select, tabIndex: 0 }, element.props));
    };
    return Radio;
}(React.Component));
exports.Radio = Radio;
var Box = function (props) {
    var onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, label = props.label, selected = props.selected;
    var className = cx({
        box: true,
        option: true,
        selected: selected,
    });
    return (React.createElement("div", { className: className, tabIndex: 0, onKeyUp: onKeyUp, onMouseDown: onMouseDown }, label));
};
exports.Box = Box;
var Standard = function (props) {
    var onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, label = props.label, selected = props.selected;
    var className = cx({
        standard: true,
        option: true,
        selected: selected,
    });
    var icon = selected ? icon_1.Icons.CheckCircle : icon_1.Icons.Circle;
    return (React.createElement("div", { className: className, tabIndex: 0, onKeyUp: onKeyUp, onMouseDown: onMouseDown },
        React.createElement(icon_1.Icon, { icon: icon, className: styles.icon }),
        " ",
        React.createElement("span", { className: styles.label }, label)));
};
exports.Standard = Standard;
exports.default = Radio;
//# sourceMappingURL=radio.js.map